import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { select, Store } from "@ngrx/store";
import { Observable, takeUntil } from "rxjs";
import { BaseComponent } from "src/app/base.component";
import { UpdateComponent } from "src/app/shared/components/drop-zone-options/modal/update/update.component";
import { OptionActionEnum } from "src/app/shared/data/actions-data";
import { RoleOptionEnum } from "src/app/shared/enum/roleOptionEnum";
import { TypeCards } from "src/app/shared/enum/typeCards";
import { UserHistoryActionsEnum } from "src/app/shared/enum/userHistoryActions";
import { UserHistoryServicesEnum } from "src/app/shared/enum/userHistoryService";
import { CreateUpdateAdvertisingCampaignByLocationPartner } from "src/app/shared/models/advertising-campaigns/createUpdateAdvertisingCampaignByLocationPartner";
import { SaveUserHistoryService } from "src/app/shared/services/history/saveHistory";
import { invokeCreateAdvertisingCampaignByLocation } from "src/app/store/advertisingCampaign/advertisingCampaign.actions";
import { AppStateInterface } from "src/app/store/appState.interface";
import {
  invokeFranchisedCompanyNamesByFranchise,
  invokeFranchiseList,
  resultFranchiseList,
} from "src/app/store/franchise/franchise.action";
import {
  resultFranchisedCompanyNamesByFranchiseSelector,
  resultFranchiseListSelector,
} from "src/app/store/franchise/franchise.selectors";
import {
  invokeLocationPartnersCompanyNames,
  setLocationPartnersCompanyNames,
} from "src/app/store/locationPartner/actions/get-locations.actions";
import { locationPartnersComapyNamesSelector } from "src/app/store/locationPartner/location-partner.selectors";

@Component({
  selector: "app-create-campaign",
  templateUrl: "./create-campaign.component.html",
  styleUrls: ["./create-campaign.component.scss"],
})
export class CreateCampaignComponent extends BaseComponent implements OnInit {
  @Input() selectedOption: OptionActionEnum;
  section = OptionActionEnum;

  advertisingCampaignForm: FormGroup;

  filename: string | null = null;

  allCompanyNames$: Observable<string[] | null>;
  resultAllCompanyNames: string[] = [];

  resultFranchiseList$: Observable<string[]>;
  franchiseList: string[];

  listFranchised$: Observable<string[]>;

  optionEnum: RoleOptionEnum;

  showLocationPartner: boolean = false;
  constructor(
    private store: Store<AppStateInterface>,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private saveHistory : SaveUserHistoryService
  ) {
    super(store);
    this.allCompanyNames$ = this.store
      .pipe(select(locationPartnersComapyNamesSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.resultFranchiseList$ = this.store
      .pipe(select(resultFranchiseListSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.listFranchised$ = this.store
      .pipe(select(resultFranchisedCompanyNamesByFranchiseSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.advertisingCampaignForm = this.fb.group({
      franchise: [null],
      locationPartners: [null],
    });
  }

  ngOnInit(): void {
    this.store.dispatch(resultFranchiseList({ franchiseList: [] }));
    if (
      this.selectedOption ===
      OptionActionEnum.ADMIN_CREATE_ADVERTISING_CAMPAIGN_FOR_FRANCHISE
    ) {
      this.store.dispatch(invokeFranchiseList());
      this.optionEnum = RoleOptionEnum.FRANCHISE;
    } else {
      this.store.dispatch(
        invokeLocationPartnersCompanyNames({ excludeFranchised: false })
      );
      this.optionEnum = RoleOptionEnum.LOCATION_PARTNER;
      this.showLocationPartner = true;
    }

    this.resultFranchiseList$.subscribe((result) => {
      if (result) {
        this.franchiseList = result;
      }
    });

    this.allCompanyNames$.subscribe((data) => {
      if (data) {
        this.resultAllCompanyNames = data;
      }
    });

    this.listFranchised$.subscribe((result) => {
      if (result) {
        this.resultAllCompanyNames = result;
      }
    });
  }

  onClickDismissAll() {
    this.modalService.dismissAll();
  }

  onClickBack() {
    this.onClickDismissAll();
    const modalRef = this.modalService.open(UpdateComponent, {
      centered: true,
    });
    modalRef.componentInstance.type =
      TypeCards.ADMIN_ADVERTISING_CAMPAIGN_CREATE;
    modalRef.componentInstance.isCol4 = false;
    modalRef.componentInstance.title = "advertisingCampaign.create.title";
    modalRef.componentInstance.isConfirmButton = false;
  }

  submit() {
    const locationPartnersValue =
      this.advertisingCampaignForm.get("locationPartners")?.value;

    const advertisingCampaign: CreateUpdateAdvertisingCampaignByLocationPartner =
      {
        locationPartners: Array.isArray(locationPartnersValue)
          ? locationPartnersValue
          : locationPartnersValue
          ? [locationPartnersValue]
          : [],
        title: "",
        videoLink: this.filename,
        franchiseCompanyName:
          this.advertisingCampaignForm.get("franchise")?.value,
        optionEnum: this.optionEnum,
      };
    this.store.dispatch(
      invokeCreateAdvertisingCampaignByLocation({
        campaignDto: advertisingCampaign,
      })
    );
    this.saveHistory.saveUserHistory(
      UserHistoryActionsEnum.POST,
      UserHistoryServicesEnum.CREATE_ADVERTISING_CAMPAIGN
    );
  }

  catchFileName(name: string | null) {
    this.filename = name;
  }

  fetchFranchised() {
    const selectedFranchise =
      this.advertisingCampaignForm.get("franchise")?.value;
    if (selectedFranchise) {
      this.showLocationPartner = true;
      this.store.dispatch(
        invokeFranchisedCompanyNamesByFranchise({
          companyName: selectedFranchise,
        })
      );
    } else {
      this.showLocationPartner = false;
      this.store.dispatch(
        setLocationPartnersCompanyNames({ companyNames: [] })
      );
    }

    this.advertisingCampaignForm.get("locationPartners")?.setValue(null);
  }

  selectAllLocations(event: any) {
    if (event.target.checked)
      this.advertisingCampaignForm
        .get("locationPartners")
        ?.setValue(this.resultAllCompanyNames);
    else this.advertisingCampaignForm.get("locationPartners")?.setValue(null);
  }

  isAllSelected() {
    const locations =
      this.advertisingCampaignForm.get("locationPartners")?.value ?? [];
    if (locations.length === this.resultAllCompanyNames.length) {
      return true;
    } else return false;
  }
}
